import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, List, X } from '@phosphor-icons/react';
import { useCart } from '../context/CartContext';
import { useState } from 'react';

const LOGO_URL = 'https://i.imgur.com/8iD261r.jpeg';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/shop', label: 'Shop' },
  { to: '/shop?category=candles', label: 'Candles' },
  { to: '/shop?category=wax_melts', label: 'Wax Melts' },
  { to: '/shop?category=skincare', label: 'Skincare' },
  { to: '/shop?category=lipgloss', label: 'Lip Gloss' },
  { to: '/about', label: 'About' },
];

export default function Header() {
  const { cartCount, setIsOpen } = useCart();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
    <div className="bg-[#C4A35A] text-[#0A0A0A] text-center py-2 text-xs sm:text-sm font-medium tracking-wide fixed top-0 left-0 right-0 z-[60]" data-testid="free-shipping-banner">
      FREE SHIPPING ON ORDERS $25+
    </div>
    <header className="cc-glass-header fixed top-8 left-0 right-0 z-50" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16 sm:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
          <img src={LOGO_URL} alt="CandleCraze Designs & More" className="h-10 sm:h-14 w-10 sm:w-14 rounded-md object-cover" />
          <div className="hidden sm:block">
            <p className="font-['Cormorant_Garamond'] text-lg sm:text-xl font-semibold text-[#E8D5A3] leading-tight">CandleCraze</p>
            <p className="text-[10px] tracking-[0.15em] uppercase text-[#9A8E7A]">Designs & More</p>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map(link => (
            <Link
              key={link.label}
              to={link.to}
              className={`text-sm tracking-wide transition-colors duration-200 hover:text-[#C4A35A] ${
                location.pathname === link.to ? 'text-[#C4A35A] font-medium' : 'text-[#9A8E7A]'
              }`}
              data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Right Side */}
        <div className="flex items-center gap-4">
          <button
            onClick={() => setIsOpen(true)}
            className="relative p-2 hover:bg-[#1E1E1E] rounded-full transition-colors"
            data-testid="cart-button"
          >
            <ShoppingBag size={22} weight="light" className="text-[#E8D5A3]" />
            {cartCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 bg-[#C4A35A] text-[#0A0A0A] text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center" data-testid="cart-count">
                {cartCount}
              </span>
            )}
          </button>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 hover:bg-[#1E1E1E] rounded-full transition-colors"
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X size={22} weight="light" className="text-[#E8D5A3]" /> : <List size={22} weight="light" className="text-[#E8D5A3]" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileOpen && (
        <nav className="lg:hidden bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-[#C4A35A]/10 px-6 py-6 space-y-4" data-testid="mobile-nav">
          {navLinks.map(link => (
            <Link
              key={link.label}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className="block text-sm tracking-wide text-[#9A8E7A] hover:text-[#C4A35A] transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
    </>
  );
}
